<template>
  <div style="width: 100%;height:100%;">

    <el-row style="position: fixed;top:20px;right: 20px;">
      <el-col :span="12">
        <el-dropdown @command="handleCommand" trigger="click" >
          <el-button icon="el-icon-s-operation" style="font-size:14px;"></el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="index1">{{ $t("message.home") }}</el-dropdown-item>
            <el-dropdown-item command="index2">{{ $t("message.scope") }}</el-dropdown-item>
            <el-dropdown-item command="index3">{{ $t("message.service") }}</el-dropdown-item>
            <el-dropdown-item command="index4">{{ $t("message.partners") }}</el-dropdown-item>
            <el-dropdown-item command="index5">{{ $t("message.contact") }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
      <el-col :span="12">
        <el-select @change="onChange" style="text-align: left" v-model="language" placeholder="请选择">
          <el-option label="中文" value="zh"></el-option>
          <el-option label="English" value="en"></el-option>
        </el-select>

      </el-col>
    </el-row>




    <div id="index1" style="background-color: #0e9e7a;height: 100vh;display:flex;justify-content: center; align-items:center;width: 100%;">
      <div style="text-align: center;" class="div1">
        <img :src="'/api/file/check-image?filePath='+homeData.imagePath"  style="width: 250px" />
        <div class="title1" style="color: #FFF;margin-top: 7%;">{{homeData.title[language]}}</div>
      </div>
    </div>

    <div style="text-align: center;font-size: 14px;color: #333;width: 100%;">
      <!-- 第一段 -->
      <div id="index2" style="padding:95px 0;width: 40%;margin: auto">
        <div style="font-size: 24px;">{{scopeInfoData.title[language]}}</div>
        <p style="border-top: 1px solid #3bbe7a;width: 30px;margin: 15px auto 40px;"></p>
        <p style="text-align: left;line-height: 30px;margin: 0 0 10px;">{{scopeInfoData.content[language]}}</p>
      </div>

      <div  style="padding-bottom:130px;">
        <el-row class="row1" style="margin: auto;">
          <el-col :sm="24" :md="6" v-for="(scopeDetail,index) in scopeDetailList" :key="scopeDetail.id">
            <div class="div2" style="color:#666666cc;padding-bottom:50px;">
              <div class="div3"
                style="width: 140px;height: 140px;border-radius: 140px;border: 3px solid #3bbe7a;margin: 0 auto;display: flex;justify-content: center;align-items: center;">
                <i v-if="index === 0" class="el-icon-monitor" style="font-size: 64px;color: #3bbe7a;"></i>
                <i v-if="index === 1" class="el-icon-data-line" style="font-size: 64px;color: #3bbe7a;"></i>
                <i v-if="index === 2" class="el-icon-trophy" style="font-size: 64px;color: #3bbe7a;"></i>
                <i v-if="index === 3" class="el-icon-files" style="font-size: 64px;color: #3bbe7a;"></i>
              </div>
              <div style="padding-top:35px;margin-bottom: 15px;font-size: 19px;width: 100%;" >{{scopeDetail.title[language]}}</div>
              <div style="font-size: 15px;line-height: 25px;" v-html="scopeDetail.content[language]"></div>
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- 第二段 -->
      <div id="index3" style="background-color:#f8f8f8;width: 100%;padding-top: 175px;">
        <div style="font-size: 24px;">{{ $t("message.myService") }}</div>
        <p style="border-top: 1px solid #3bbe7a;width: 30px;margin: 15px auto 40px;"></p>
        <div style="width:61%;margin: auto;padding-bottom:80px;padding-top: 15px;">
          <el-row :gutter="30">
            <el-col :md="24" :lg="6" v-for="serviceInfo in serviceInfoList" :key="serviceInfo.id">
              <div class="tile" >
                <div class="text" style="width: 100%;height: 100%;">
                  <div style="text-align: left;font-weight: 300;text-shadow: 2px 2px 10px rgba(0, 0, 0, .3);font-size: 25px;position: absolute;z-index: 11;
  left: 20px;
  top: 1px;">{{serviceInfo.title[language]}}</div>
                  <img style="width: 100%;height: 263px" :src="'/api/file/check-image?filePath='+serviceInfo.imagePath">
                  <p class="animate-text" style="padding-left: 20px;padding-right: 20px;height: 200px;margin-top: 65px;overflow: auto;text-align: left;">
                    {{serviceInfo.content[language]}}
                  </p>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>

      <!-- 第三段 -->
      <div id="index4" style="padding-top: 95px;">
        <div style="font-size: 24px;">{{ $t("message.excellentPartners") }}</div>
        <p style="border-top: 1px solid #3bbe7a;width: 30px;margin: 15px auto 40px;"></p>
        <div style="text-align:center">
          <img v-for="partnersInfo in partnersInfoList" :key="partnersInfo.id" :src="'/api/file/check-image?filePath='+partnersInfo.imagePath" style="margin:0 auto;    display: block;max-width: 50%;height: auto;" />
        </div>
      </div>

      <div id="index5" style="margin-top: 50px">
        <img src="../../assets/map.jpg"  />
      </div>
      <footer id="contact" style="background-color: #333;padding:75px 0;">
        <el-row>
          <el-col :span="16" style="text-align: left;padding-left: 20%;">
            <div class="footer-legal-links"
              style="margin-bottom: 10px;overflow: hidden;color: rgba(102, 102, 102, .8);">
              {{ $t("message.address") }}：武汉市洪山区邮科院路88号烽火创新谷3号楼4F
            </div>
            <div class="footer-legal-links"
              style="margin-bottom: 10px;overflow: hidden;color: rgba(102, 102, 102, .8);">
              {{ $t("message.phone") }}：027-87691179
            </div>
            <div class="footer-beizhu" style="font-size: 12px;color: rgba(102, 102, 102, .8);">
              Copyright © 2018 武汉市悠然智在科技有限责任公司
              <a href="http://beian.miit.gov.cn/" target="_blank" style="color:#337ab7;">鄂ICP备15022194号</a>
            </div>
          </el-col>
          <el-col :span="5">
            <img src="../../assets/weixin.jpg" style="padding-left: 15%;" />
          </el-col>
        </el-row>
      </footer>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      language:"zh",
      homeData:{},
      scopeInfoData:{},
      scopeDetailList:[],
      serviceInfoList:[],
      partnersInfoList:[]
    };
  },
  created() {
    this.getHome()
    this.getScopeInfo()
    this.getScopeDetail()
    this.getServiceInfo()
    this.getPartnersInfo()
  },
  methods: {
    handleCommand(command) {
      //box表示需要定位到的div
      const scrollTop = document.getElementById(command);
      scrollTop.scrollIntoView();
    },
    onChange(){
      this.$i18n.locale = this.language;
    },
    getHome(){
      this.axios({
        method: "get",
        url: "/y-home-info/detail"
      }).then((res) => {
        this.homeData = res.data.data
        this.homeData.title = JSON.parse(this.homeData.title)
      });
    },
    getScopeInfo(){
      this.axios({
        method: "get",
        url: "/y-scope-info/detail"
      }).then((res) => {
        this.scopeInfoData = res.data.data
        this.scopeInfoData.title = JSON.parse(this.scopeInfoData.title)
        this.scopeInfoData.content = JSON.parse(this.scopeInfoData.content)
      });
    },
    getScopeDetail(){
      this.axios({
        method: "get",
        url: "/y-scope-detail/list"
      }).then((res) => {
        this.scopeDetailList = res.data.data.list;
        for(let i=0;i<this.scopeDetailList.length;i++){
          this.scopeDetailList[i].title = JSON.parse(this.scopeDetailList[i].title)
          this.scopeDetailList[i].content = JSON.parse(this.scopeDetailList[i].content)
        }
      });
    },
    getServiceInfo(){
      this.axios({
        method: "get",
        url: "/y-service-info/list"
      }).then((res) => {
        this.serviceInfoList = res.data.data.list;
        for(let i=0;i<this.serviceInfoList.length;i++){
          this.serviceInfoList[i].title = JSON.parse(this.serviceInfoList[i].title)
          this.serviceInfoList[i].content = JSON.parse(this.serviceInfoList[i].content)
        }
      });
    },
    getPartnersInfo(){
      this.axios({
        method: "get",
        url: "/y-partners-info/list"
      }).then((res) => {
        this.partnersInfoList = res.data.data.list;
      });
    }
  },
};
</script>

<style>
@media (min-width: 1200px) {
  .container {
    width: 1170px;
  }
}

@media (min-width: 992px) {
  .container {
    width: 970px;
  }
}

@media (min-width: 768px) {
  .container {
    width: 750px;
  }
}

.tile {
  width: 100%;
  min-height: 263px;
  margin: 20px auto;
  background-color: #0e9e7a;
  display: inline-block;
  background-size: cover;
  position: relative;
  cursor: pointer;
  transition: all .4s ease-out;
  box-shadow: 0 35px 77px -17px rgba(0, 0, 0, .44);
  overflow: hidden;
  color: #fff;
}

.tile:hover {
  box-shadow: 0 35px 77px -17px rgba(0, 0, 0, .64);
  transform: scale(1.05);
}

.tile .text {
  z-index: 2;
  position: absolute;
}

.tile span {
  font-weight: 300;
  text-shadow: 2px 2px 10px rgba(0, 0, 0, .3);
  font-size: 25px;
  position: absolute;
  z-index: 11;
  left: 20px;
  text-align: center;
  top: 1px;
}

.tile img {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  transition: all .4s ease-out;
}

.tile:hover img {
  opacity: .2;
}

.tile p {
  font-size: 12px;
  text-align: left;
  font-weight: 300;
  margin-top: 35px;
  line-height: 20px;
  transform: translateX(-270px);
  transition-delay: .2s;
}

.animate-text {
  opacity: 0;
  transition: all .6s ease-in-out;
  overflow: auto;
}

.tile:hover .animate-text {
  transform: translateX(0);
  opacity: 1;
}

@media (max-width: 1024px) {
  .title1 {
    font-size: 40px;
  }
}

@media (max-width: 768px) {
  .title1 {
    font-size: 30px;
  }
}

@media (min-width: 768px) {
  .title1 {
    font-size: 66px;
  }
}

@media (max-width: 1440px) {
  .row1 {
    width: 80%;
  }
}

@media (min-width: 1441px) {
  .row1 {
    width: 60%;
  }
}

.div2:hover {
  color: #3bbe7a !important;
}

.div2:hover .div3 {
  background-color: #3bbe7a !important;
}

.div2:hover i {
  color: #fff !important;
}
</style>